module.exports = __webpack_public_path__ + "static/media/media-owner-benefit-flat-3-1.f16a00e2.svg";